import { Form } from 'antd';
import { useUpdateExpoBoothNo } from 'features/transaction_list/use-cases/update-expo-booth-number';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';


export const RefundViewModal = ({ onClose, isOpen, RefundData }: any) => {
    
    const formName = 'edit-booth-name-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<any>();

    const { isLoading, mutate } = useUpdateExpoBoothNo();
    const [editBoothId, setEditBoothId] = useState<number | null>(null)

    const location = useLocation();

    const pageFlag = location.pathname == "/transactions/expo-booth-list" ? 'BOOTH' : 'TICKETS';

    useEffect(() => {
        form.resetFields();
    }, [isOpen])

    const handleClose = () => {
        setEditBoothId(null);
        form.resetFields();
        onClose();
    };

    const handleUpdate = (formData: any) => {
        const payload = {
            Flag: "CHANGE",
            booth_no_old: editBoothId,      // Old booth id
            booth_no_new: +formData.booth_name,  // New booth name from form input
            pageFlag: pageFlag
        };
        mutate(payload, { onSuccess: handleClose });
    };


    return (

        <>
            <div className='popup'>
                <div className='modal_head'>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                    <h4>Refund Details</h4>
                </div>
                <div className='modal_body'>
                    <Form
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        // initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        // requiredMark={'optional'}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <FormSectionsSeparator title={""}>
                            <div className="main_data">
                                <div className="data_bx">
                                    <label>Event Name</label>
                                    <span>{RefundData?.EventName}</span>

                                </div>

                                <div className="data_bx">
                                    <label>PaymentType</label>
                                    <span>{RefundData?.PaymentType}</span>
                                </div>
                                <div className="data_bx">
                                    <label>PhoneNumber</label>
                                    <span>{RefundData?.PhoneNumber}</span>
                                </div>
                                <div className="data_bx">
                                    <label>UserName</label>
                                    <span>{RefundData?.UserName}</span>
                                </div>
                                <div className="data_bx">
                                    <label>RefundAmount</label>
                                    <span>{RefundData?.RefundAmount}</span>
                                </div>
                                <div className="data_bx">
                                    <label>ActionBy</label>
                                    <span>{RefundData?.RefundStatus}</span>
                                </div>
                            </div>
                        </FormSectionsSeparator>
                    </Form>
                </div>
            </div>
        </>
    );
};
